import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';

import { CerAuthorizeService } from 'src/cer-identity/cer-authorize.service';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
})
export class ConfirmEmailComponent implements OnInit {
  success = true;

  constructor(private authService: CerAuthorizeService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {}

  public ngOnInit(): void {
    this.authService.user$.pipe(take(1)).subscribe({
      next: (user) =>{
        if (user) {
          this.router.navigateByUrl('/');
        } else {
          this.activatedRoute.queryParamMap.subscribe({
            next: (params: any) => {
              var token: string = params.get('token');
              var email: string = params.get('email');

              this.authService.confirmEmail(token, email).subscribe({
                next: (response: any) => {
                  this.authService.showNotification(true, response.value.title, response.value.message);
                  this.authService.navigateToLogin();
                }, error: error => {
                  this.success = false;
                  this.authService.showNotification(false, "Failed", error.error);
                }
              })
            }
          })
        }
      }
    })
  }

  protected resendEmailConfirmationLink() {
    this.authService.navigateToResendEmailConfirmationLink();
  }

}
